import React, { useState } from 'react'
import styles from '../CustomDomainModal.module.css'
import { getFirstPart, CopyIcon } from '../constants/utils'
import CustomTooltip from 'components/CustomTooltip'
import { useCustomDomain } from '../context/CustomDomainProvider'
import { Spinner } from 'react-bootstrap'
import { ErrorBox } from 'components/ErrorBox/ErrorBox'
import { ERROR_MSGS } from '../../../constants'

const DNSTable = ({ data, domain, DNSRecordsDiagnosticsProps, loading }) => {
  const { DNSRecordsDiagnostics } = useCustomDomain()
  const diagnosticsData = DNSRecordsDiagnosticsProps || DNSRecordsDiagnostics

  if (diagnosticsData?.error) {
    const errorCode = diagnosticsData.error.code
    const errorMessage = ERROR_MSGS[errorCode]
    if (errorMessage) {
      return <ErrorBox message={errorMessage} hideButton />
    } else {
      return <ErrorBox message="Oops, something went wrong" hideButton />
    }
  }

  if (
    diagnosticsData &&
    (!diagnosticsData?.success || DNSRecordsDiagnosticsProps) &&
    diagnosticsData?.records?.length
  ) {
    return (
      <>
        {loading ? (
          <div className={styles.spinnerContainer}>
            <Spinner animation="border" size="sm" />
          </div>
        ) : (
          diagnosticsData.records.map((record, index) => (
            <div className={styles.table} key={index}>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Type:</span>
                <span className={styles.dnsValue}>
                  {record.type} <CopyIcon text={record.type} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Name/Host:</span>
                <span className={styles.dnsValue}>
                  {record.name} <CopyIcon text={record.name} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Expected:</span>
                <span className={styles.dnsValue}>
                  {record.expected}
                  <CopyIcon text={record.expected} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={record.matches ? styles.dnsLabelDiagnosticsSuccess : styles.dnsLabelDiagnosticsFailed}>
                  Found:
                </span>
                <span className={record.matches ? styles.dnsValueDiagnosticsSuccess : styles.dnsValueDiagnosticsFailed}>
                  {record.found.join(', ')}
                </span>
                {record.matches && (
                  <span className={styles.iconCheck}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-check"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                    </svg>
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </>
    )
  }

  return (
    <>
      {loading ? (
        <div className={styles.spinnerContainer}>
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        data &&
        data?.records &&
        data?.records.map((record, index) => {
          const suffix = record?.type === 'A' ? `${domain}` : `${getFirstPart(record?.host)}.${domain}`
          return (
            <div className={styles.table} key={index}>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Type:</span>
                <span className={styles.dnsValue}>
                  {record?.type} <CopyIcon text={record?.type} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Name/Host:</span>
                <span className={styles.dnsValue}>
                  {getFirstPart(record?.host)} <CopyIcon text={getFirstPart(record?.host)} />
                </span>
              </div>
              <div className={styles.record}>
                <span className={styles.dnsLabel}>Value:</span>
                <span className={styles.dnsValue}>
                  {record?.value}
                  <CopyIcon text={record?.value} />
                </span>
              </div>
              {/* <span className={styles.test}>
                <CustomTooltip label="Click 'Search' on DNSChecker.org & verify the records match EXACTLY">
                  <a href={`https://dnschecker.org/#${record?.type}/${suffix}`} target="_blank" rel="noreferrer">
                    Test connection →
                  </a>
                </CustomTooltip>
              </span> */}
            </div>
          )
        })
      )}
    </>
  )
}

export default DNSTable
